import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  section: {
    width: '100%',
    backgroundColor: '#070711',
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '60px',
    position: 'relative',
    overflow: 'hidden',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '1200px',
    width: '100%',
    padding: '0 20px',
    position: 'relative',
    zIndex: 5,
  },
  spotlightImg: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
    zIndex: '-5',
    maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0.6), rgba(0,0,0,0))',
    WebkitMaskImage: 'linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0.6), rgba(0,0,0,0))',
    filter: 'blur(2px)',
    [theme.breakpoints.down('md')]: {
      width: '150%',
    },
  },
  heading: {
    fontSize: '48px !important',
    fontStyle: 'normal',
    fontWeight: '500 !important',
    letterSpacing: '-0.96px !important',
    textAlign: 'center',
    marginTop: '160px !important',
    textShadow: '0px 4px 28.9px rgba(255, 255, 255, 0.15) !important',
    background: 'linear-gradient(180deg, #FFF 0%, #90B3E8 85.37%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    color: '#FFFFFF',
    [theme.breakpoints.down('md')]: {
      fontSize: '32px !important',
      marginTop: '80px !important',
    },
  },
  subtext: {
    width: '40%',
    fontFamily: 'Onest, sans-serif',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'center',
    color: '#BBB',
    margin: '10px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
      textWrap: 'wrap',
      width: '80%',
    },
  },
  zeeLogo: {
    height: 'auto',
    width: '100px',
    margin: '20px !important',
    [theme.breakpoints.down('md')]: {
      margin: '10px 0 30px 0 !important',
    },
  },
  cardsWrapper: {
    display: 'flex',
    gap: '24px',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginTop: '24px !important',
    marginBottom: '40px',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      flexWrap: 'no-wrap',
      flexDirection: 'column !important',
    },
  },
  card: {
    display: 'flex',
    padding: '28px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
    flex: '1 0 0',
    alignSelf: 'stretch',
    borderRadius: '12px',
    border: '1px solid #1E1E1E',
    background: 'rgba(13, 13, 13, 0.32)',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      width: '80%',
      padding: '20px 16px',
      flexDirection: 'row',
      gap: '12px',
    },
  },
  cardLeft: {
    [theme.breakpoints.down('md')]: {
      alignSelf: 'flex-start',
    },
  },
  cardRight: {
    [theme.breakpoints.down('md')]: {
      alignSelf: 'flex-end',
    },
  },
  cardIcon: {
    width: '36px',
    height: '36px',
    marginBottom: '16px',
    [theme.breakpoints.down('lg')]: {
      width: '24px',
      height: '24px',
    },
  },
  cardText: {
    color: '#919EB1',
    fontFamily: 'Onest',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '151%',
    [theme.breakpoints.down('lg')]: {
      fontSize: '14px',
    },
  },
  ctaBtn: {
    display: 'flex',
    padding: '18px 64px !important',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    borderRadius: '6px',
    border: '1px solid #1E1E1E',
    background: `linear-gradient(
    102deg,
    rgba(216, 81, 140, 0.70) -4.44%,
    rgba(96, 35, 177, 0.70) 30.79%,
    rgba(39, 0, 157, 0.70) 54.75%,
    rgba(0, 25, 134, 0.70) 104.14%
  ), rgba(13, 13, 13, 0.50)`,
    color: '#C4C2E7 !important',
    fontSize: '16px',
    fontWeight: '600 !important',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
}));
